import type { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

interface AdminPageHeaderProps {
  title: string
  description: ReactNode
  eyebrow?: string
  actions?: ReactNode
  icon?: ReactNode
}

export function AdminPageHeader({ title, description, eyebrow, actions, icon }: AdminPageHeaderProps) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: { xs: 'stretch', sm: 'flex-start' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      mb: 3,
    }}>
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && (
          <Typography sx={{
            color: 'primary.main', fontWeight: 800, fontSize: 11,
            letterSpacing: '0.1em', textTransform: 'uppercase', mb: 0.65,
          }}>
            {eyebrow}
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          {icon && (
            <Box sx={{
              width: 38, height: 38, borderRadius: 2.25, bgcolor: 'primary.50',
              color: 'primary.main', display: 'grid', placeItems: 'center', flexShrink: 0,
              '& svg': { fontSize: 21 },
            }}>
              {icon}
            </Box>
          )}
          <Typography variant="h4" sx={{
            color: 'text.primary', fontSize: { xs: 24, md: 28 },
            lineHeight: 1.2, letterSpacing: '-0.035em',
          }}>
            {title}
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.75, maxWidth: 720, lineHeight: 1.55 }}>
          {description}
        </Typography>
      </Box>
      {actions && (
        <Box sx={{
          display: 'flex', gap: 1, flexWrap: 'wrap', flexShrink: 0,
          '& .MuiButton-root': { flex: { xs: '1 1 auto', sm: '0 0 auto' } },
        }}>
          {actions}
        </Box>
      )}
    </Box>
  )
}
